var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { GroupFilter } from './GroupFilters';
import { GroupToolbar } from './GroupToolbar';
import { validatePackage, templateRendering, getListeners } from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { filterAriaLabel, messages } from '../messages/main';
/**
 * @hidden
 */
var FilterVue2 = {
  name: 'KendoFilter',
  // @ts-ignore
  emits: {
    change: null,
    'changemodel': null,
    'update:modelValue': null
  },
  model: {
    event: 'changemodel'
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Object,
      default: undefined
    },
    value: Object,
    defaultGroupFilter: Object
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  computed: {
    computedValue: function computedValue() {
      var value;
      if (this.$props.value !== undefined) {
        value = this.$props.value;
      } else if (this.$props.modelValue !== undefined) {
        value = this.$props.modelValue;
      }
      return value;
    }
  },
  render: function render(createElement) {
    var locService = provideLocalizationService(this);
    var h = gh || createElement;
    var fields = this.$props.fields.map(function (field) {
      return __assign(__assign({}, field), {
        filterRender: templateRendering.call(this, field.filterRender, getListeners.call(this))
      });
    }, this);
    return h("div", {
      "class": 'k-widget k-filter'
    }, [h("ul", {
      "class": "k-filter-container",
      role: "tree",
      attrs: this.v3 ? undefined : {
        role: "tree",
        ariaLabel: locService.toLanguageString(filterAriaLabel, messages[filterAriaLabel])
      },
      ariaLabel: locService.toLanguageString(filterAriaLabel, messages[filterAriaLabel])
    }, [h("li", {
      "class": "k-filter-group-main",
      role: "treeitem",
      attrs: this.v3 ? undefined : {
        role: "treeitem"
      }
    }, [
    // @ts-ignore function children
    h(GroupToolbar, {
      filter: this.computedValue,
      attrs: this.v3 ? undefined : {
        filter: this.computedValue,
        fields: fields,
        defaultGroupFilter: this.$props.defaultGroupFilter || {
          logic: 'and',
          filters: []
        }
      },
      fields: fields,
      onChange: this.onFilterChange,
      on: this.v3 ? undefined : {
        "change": this.onFilterChange,
        "remove": this.onGroupRemove
      },
      onRemove: this.onGroupRemove,
      defaultGroupFilter: this.$props.defaultGroupFilter || {
        logic: 'and',
        filters: []
      }
    }),
    // @ts-ignore function children
    h(GroupFilter, {
      filter: this.computedValue,
      attrs: this.v3 ? undefined : {
        filter: this.computedValue,
        fields: fields,
        defaultGroupFilter: this.$props.defaultGroupFilter || {
          logic: 'and',
          filters: []
        }
      },
      fields: fields,
      onChange: this.onFilterChange,
      on: this.v3 ? undefined : {
        "change": this.onFilterChange,
        "remove": this.onGroupRemove
      },
      onRemove: this.onGroupRemove,
      defaultGroupFilter: this.$props.defaultGroupFilter || {
        logic: 'and',
        filters: []
      }
    })])])]);
  },
  methods: {
    onFilterChange: function onFilterChange(event) {
      var changeEvent = {
        filter: event.nextFilter,
        event: event.event,
        target: this
      };
      this.$emit('changemodel', event.nextFilter);
      this.$emit('update:modelValue', event.nextFilter);
      this.$emit('change', changeEvent);
    },
    onGroupRemove: function onGroupRemove(event) {
      var nextFilter = __assign(__assign({}, this.computedValue), {
        filters: []
      });
      var changeEvent = {
        filter: nextFilter,
        event: event.event,
        target: this
      };
      this.$emit('changemodel', nextFilter);
      this.$emit('update:modelValue', nextFilter);
      this.$emit('change', changeEvent);
    }
  }
};
/**
 * @hidden
 */
var Filter = FilterVue2;
export { Filter, FilterVue2 };